import { fetchCRONExpressions } from '@home/services/common';

import type { Action, Reducer, Effect } from 'umi';
import type { IConditionalRule } from '@home/types/common';

export interface ICRONExpressionsState {
  loading: boolean;
  data: IRecord<IConditionalRule>;
}

type IUpdateCRONExpressionStatesAction = Action<'updateCRONExpressionsState'> & {
  type: string;
  payload: ICRONExpressionsState;
};

export interface ICRONExpressionsModel {
  namespace: string;
  state: ICRONExpressionsState;
  effects: {
    getCRONExpressions: Effect;
  };
  reducers: {
    updateCRONExpressionsState: Reducer<ICRONExpressionsState, IUpdateCRONExpressionStatesAction>;
  };
}

export const CRON_EXPRESSIONS_MODEL_NAMESPACE = 'dbh-model-cron-expressions';

export const DEFAULT_CRON_EXPRESSIONS: IRecord<IConditionalRule> = {};

export const DEFAULT_CRON_EXPRESSIONS_STATE: ICRONExpressionsState = {
  loading: true,
  data: DEFAULT_CRON_EXPRESSIONS,
};

const CRONExpressionsModel: ICRONExpressionsModel = {
  namespace: CRON_EXPRESSIONS_MODEL_NAMESPACE,
  state: DEFAULT_CRON_EXPRESSIONS_STATE,
  effects: {
    *getCRONExpressions(action, { call, put }) {
      yield put({
        type: 'updateCRONExpressionsState',
        payload: { loading: true, data: DEFAULT_CRON_EXPRESSIONS_STATE },
      });
      const { data } = yield call(fetchCRONExpressions);
      const cronExpressions = data?.cron_expressions || [];
      const cronExpressionsMap = (() => {
        if (!Array.isArray(cronExpressions) || cronExpressions.length === 0) return DEFAULT_CRON_EXPRESSIONS;
        return cronExpressions.reduce((acc, cur) => {
          const tag = cur?.tag || '';
          return { ...acc, [tag]: cur };
        }, {});
      })();
      yield put({
        type: 'updateCRONExpressionsState',
        payload: { loading: false, data: cronExpressionsMap },
      });
    },
  },
  reducers: {
    updateCRONExpressionsState(state, action) {
      const payload = action?.payload || {};
      return { ...state, loading: !!payload?.loading, data: payload?.data || DEFAULT_CRON_EXPRESSIONS };
    },
  },
};

export default CRONExpressionsModel;
